import React, { useEffect, useState } from 'react'
import { api } from '../../utils/api'
import { summariseTopicCounts, weekStarts } from './topicCounts.js'

/** This week plus the 13 full weeks before it: about the 90-day baseline in the spec. */
const WEEKS_FETCHED = 14
const BASELINE_WEEKS = WEEKS_FETCHED - 1

/**
 * Tickets per topic: this week, last week, and the weekly average before this
 * week (inbox deflection W1). Shows whether each change cut its topic.
 */
export default function TopicCountsModal({ onClose }) {
  const [lines, setLines] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    api.get(`/api/tickets/topic-counts?weeks=${WEEKS_FETCHED}`)
      .then(response => {
        if (cancelled) return
        setLines(summariseTopicCounts(response.rows || [], { ...weekStarts(new Date()), baselineWeeks: BASELINE_WEEKS }))
      })
      .catch(err => { if (!cancelled) setError(err.message) })
    return () => { cancelled = true }
  }, [])

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalContent" onClick={e => e.stopPropagation()} style={{ maxWidth: 560 }} role="dialog" aria-label="Tickets by topic">
        <div className="modalHead">
          <h2>Tickets by topic</h2>
          <button className="modalClose" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="modalBody">
          {error && <p style={{ color: 'var(--danger, #dc2626)' }}>Could not load the counts: {error}</p>}
          {!error && !lines && <p>Loading…</p>}
          {lines && lines.length === 0 && <p>No tickets in the last {WEEKS_FETCHED} weeks.</p>}
          {lines && lines.length > 0 && (
            <table className="table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Topic</th>
                  <th style={{ textAlign: 'right' }}>This week</th>
                  <th style={{ textAlign: 'right' }}>Last week</th>
                  <th style={{ textAlign: 'right' }}>Weekly average</th>
                </tr>
              </thead>
              <tbody>
                {lines.map(line => (
                  <tr key={line.key ?? 'none'}>
                    <td>{line.label}</td>
                    <td style={{ textAlign: 'right' }}>{line.thisWeek}</td>
                    <td style={{ textAlign: 'right' }}>{line.lastWeek}</td>
                    <td style={{ textAlign: 'right' }}>{line.baseline}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <p style={{ fontSize: 12, color: 'var(--muted)' }}>
            Weekly average covers the {BASELINE_WEEKS} weeks before this one. Weeks start on Monday.
          </p>
        </div>
      </div>
    </div>
  )
}
